<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import simplebar from "simplebar-vue";
import API from "@/router/layouts/API";
import CopyableText from "@/components/CopyableText";

export default {
  page: {
    title: "GameLabs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    simplebar,
    API,
    CopyableText
  },
  data() {
    return {

    };
  },
  validations: {

  },
  methods: {
    goto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView({ block: 'end', behavior: 'smooth' });
      this.$nextTick(() => {
        //document.scrollingElement.scrollTop -= 1;
      });
    },
  }
};
</script>

<template>
  <API>
    <!-- LINKS -->
    <template v-slot:contents>
      <ul class="c-menu">
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('introduction')"
          >
            Introduction
          </a>
        </li>
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('classes')"
          >
            Dataclasses
          </a>
        </li>
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('core')"
          >
            GameLabs core
          </a>
        </li>
      </ul>
    </template >
    <!-- CONTENT -->
    <template v-slot:content>
      <!-- Introduction -->
      <div class="c-api-section" ref="introduction">
        <h1 class="pb-0">
          Introduction
        </h1>
        <hr>
        <div class="c-api-content">
          GameLabs for DayZ comes in form of a client or server side mod available from
          <a href="https://steamcommunity.com/sharedfiles/filedetails/?id=2464526692" target="_blank">https://steamcommunity.com/sharedfiles/filedetails/?id=2464526692</a>.
          <br>
          <br>
          It aims at providing a game integration for the CFTools Cloud platform and a way for modders to better interact with server aspects and CFTools Cloud.
          <br>
          Feature requests and bug reports may be filed via <a href="https://github.com/CFToolsGameLabs/game-plugin-dayz" target="_blank">https://github.com/CFToolsGameLabs/game-plugin-dayz</a>.
          <br>
          <br>
          GameLabs exposes itself via several public methods. These can be optionally implemented or required upon.
          For an optional implementation you can use <CopyableText class="text-code text-info" text="#ifdef GAMELABS"/> respectively.
        </div>
      </div>
      <!-- Server Id -->
      <div class="c-api-section" ref="classes">
        <h1 class="pb-0">
          Dataclasses
        </h1>
        <hr>
        <div class="c-api-content">
          The public API of GameLabs is work in progress and exposes following classes.
          <br>
          <div class="c-api-spacer"/>
          <h3>
            <CopyableText class="text-code text-primary" text="_Event" />
          </h3>
          Used to track dynamic events and transmit them to the CFTools Cloud live map
          <table class="table table-bordered">
            <thead>
            <th>Access</th>
            <th>Type</th>
            <th>Attribute</th>
            <th>Notes</th>
            </thead>
            <tbody>
            <tr>
              <td><span class="text-code text-info">private</span></td>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="id"/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><span class="text-code text-info">private</span></td>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="icon"/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><span class="text-code text-info">private</span></td>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="className"/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><span class="text-code text-info">private</span></td>
              <td><span class="text-code text-warning">Object</span></td>
              <td>
                <CopyableText class="text-code text-success" text="_reference"/>
              </td>
              <td></td>
            </tr>
            </tbody>
          </table>


          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="_Event(string className, string icon, Object _reference)" />
          </h4>
          <table class="table table-bordered">
            <thead>
            <th>Type</th>
            <th>Parameter</th>
            <th>Value</th>
            <th>Notes</th>
            </thead>
            <tbody>
            <tr>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="className"/>
              </td>
              <td>
                Class name of the object or a custom string to be displayed on the live map
              </td>
              <td>

              </td>
            </tr>
            <tr>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="icon"/>
              </td>
              <td>
                A FontAwesome icon to be used as representation on the live map
              </td>
              <td>
                The color is not customizable. The icon type will always be <span class="text-code text-success">far</span> (Regular).
              </td>
            </tr>
            <tr>
              <td><span class="text-code text-warning">Object</span></td>
              <td>
                <CopyableText class="text-code text-success" text="_reference"/>
              </td>
              <td>
                A reference to the tracked object. Can not be a proxy or a custom one, must be a hard ref to the instance.
              </td>
              <td>

              </td>
            </tr>
            </tbody>
          </table>

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="string GetID()" />
          </h4>
          Returns the network id string of the _Event instance for unique identification

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="string Class()" />
          </h4>
          Returns the <CopyableText class="text-code text-success" text="className"/> attribute

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="string Icon()" />
          </h4>
          Returns the <CopyableText class="text-code text-success" text="icon"/> attribute

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="Object Ref()" />
          </h4>
          Returns the <CopyableText class="text-code text-success" text="_reference"/> attribute

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="bool Equals(_Event other)" />
          </h4>
          Compares two instances of <CopyableText class="text-code text-success" text="_Event"/>
        </div>
      </div>

      <div class="c-api-section" ref="classes">
        <h1 class="pb-0">
          GameLabs Core
        </h1>
        <hr>
        <div class="c-api-content">
          GameLabs Core is the core system which holds and processes all data on the server side.
          <br>
          <div class="c-api-spacer"/>
          <h3>
            <CopyableText class="text-code text-primary" text="GameLabsCore GetGameLabs()" />
            <span class="badge badge-info text-black">
              3_Game
            </span>
          </h3>
          Access GameLabs Core. This is being first instanced during the creation of mission server. You may not instance
          this class yourself.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="bool IsProcessingBlocked()" />
          </h4>
          Check if processing of events has been blocked server side or by configuration. If this is true, do not send
          any API requests as they will most likely fail.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="bool IsServer()" />
          </h4>
          Custom check if the current environment is a server or a client.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="string GetVersionIdentifier()" />
          </h4>
          Returns a string representation of the current running GameLabs version in MAJOR.MINOR format.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="GameLabsAPI GetApi()" />
          </h4>
          Access the core (and authenticated) API wrapper.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="GameLabsLogger GetLogger()" />
          </h4>
          Access the core logger.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="GameLabsConfiguration GetConfiguration()" />
          </h4>
          Access the configuration.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="bool GetDebugStatus()" />
          </h4>
          Check if GameLabs debug mode is enabled

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="bool GetConnectionVerificationStatus()" />
          </h4>
          Check if server is supposed to exit if API connection fails.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="void RequestServerFPS()" />
            <span class="badge badge-warning text-black">
              Client-API
            </span>
          </h4>
          Request the server fps from the client side.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="int GetServerFPS()" />
          </h4>
          Get the latest server fps snapshot.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="int GetAICount()" />
          </h4>
          Get the amount of vanilla AI currently active in the world.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="int GetAIActiveCount()" />
          </h4>
          Get the amount of vanilla AI currently active (moving or processing) in the world.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="int GetAnimalCount()" />
          </h4>
          Get the amount of vanilla animals currently in the world.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="int GetVehicleCount()" />
          </h4>
          Get the amount of vehicles currently in the world.

          <div class="c-api-spacer"/>
          <h4>
            <CopyableText class="text-code text-info" text="void AddMonitoredAction(string action)" />
          </h4>
          Tell GameLabs to watch for a specific action and transmit it via the logging API.
          <table class="table table-bordered">
            <thead>
            <th>Type</th>
            <th>Parameter</th>
            <th>Value</th>
            <th>Notes</th>
            </thead>
            <tbody>
            <tr>
              <td><span class="text-code text-warning">string</span></td>
              <td>
                <CopyableText class="text-code text-success" text="action"/>
              </td>
              <td>
                Class name as string of the action you are trying to log.
              </td>
              <td>
                Action must call super on all server side execution handlers.
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </API>
</template>